// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ibngt","primary":"styles_primary__GaimM","secondary":"styles_secondary__8IsCR"};